import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../realize_overrides/components/modal/modal.jsx';

import { ModalActions, ModalStore } from '../../realize_overrides/stores/modal_store';

import mixin from 'react-mixin';

const Realize = {
	i18n: window.Realize.i18n,
	Modal: Modal,
	ModalHeader: window.ModalHeader,
	ModalContent: window.ModalContent,
	ModalFooter: window.ModalFooter
};

@mixin.decorate(Reflux.listenTo(ModalStore, "onModalAction"))
export default class CustomModalApi extends React.Component {
	static propTypes = {
		modalId: PropTypes.string,
		title: PropTypes.string,
		description: PropTypes.string,
		showButtonClose: PropTypes.bool,
		buttons: PropTypes.array,
		type: PropTypes.string,
		icon: PropTypes.bool,
		isMobile: PropTypes.bool,
		dismissible: PropTypes.bool
	};

	static defaultProps = {
		modalId: 'custom-modal-api',
		title: '-',
		description: '-',
		showButtonClose: '',
		buttons: [],
		type: '-',
		icon: true,
		isMobile: false,
		dismissible: false
	};

	constructor(props) {
		super(props);

		this.state = {
			title: '',
			type: '',
			description: '-',
			showButtonClose: '',
			icon: '',
			buttons: []
		}
	}

	onModalAction(props) {
		if(this.props.modalId === props.modalId) {
			this.setState({
				title: props.title,
				type: props.type,
				description: props.description,
				showButtonClose: props.showButtonClose,
				icon: props.icon,
				buttons: props.buttons,
			});
		}
	}

	getType(){
		return this.state.type;
	}

	getTitle() {
		return this.state.title;
	}

	getDescription() {
		return this.state.description;
	}

	getShowButtonClose(){
		return this.state.showButtonClose;
	}

	getIcon(){
		return this.state.icon;
	}

	dismissModal() {
		ModalActions.close({
			modalId: this.props.modalId
		});
	}

	getButtons(){
		return this.state.buttons;
	}

	renderDismissButton() {
		return {
			name: Realize.i18n.t('actions.close'),
			element: "a",
			role: "button",
			icon: "close",
			style: "cancel",
			onClick: this.dismissModal.bind(this)
		}
	}

	buildButtons(){
		let buttons = [];
		const getButtons = this.getButtons();
		const getButtonClose = this.getShowButtonClose();
		//const getCloseOnClick = getButtons[0].closeOnClick;

		if (!getButtons || getButtons instanceof Array === false )
			return buttons;

		getButtons.forEach(button => {
			let getCloseOnClick = button.closeOnClick;
			buttons.push({
				name: button.name,
				element: "a",
				role: "button",
				icon: button.icon,
				style: "primary",
				closeOnClick: button.closeOnClick,
				onClick: function(){
					if(getCloseOnClick !== undefined){
						if(getCloseOnClick !== true){
							button.action();
						} else {
							button.action();
							ModalActions.close({
								modalId: 'custom-modal-api'
							})
						}
					} else {
						button.action();
						ModalActions.close({
							modalId: 'custom-modal-api'
						})
					}
				}
			});
		});

		if(getButtonClose !== undefined){
			if(getButtonClose !== true){
				return [
					...buttons
				]
			} else {
				return [
					this.renderDismissButton(),
					...buttons
				]
			}
		} else {
			return [
				this.renderDismissButton(),
				...buttons
			]
		}
	}

	buildButtonGroupProps() {
		return this.buildButtons();
	}

	renderModalButtons() {
		return <ButtonGroup buttons={this.buildButtonGroupProps()} />;
	}

	iconModal(){
		const icon = this.getIcon();

		if(icon === true || icon === undefined){
			return <Spinner />
		} else {
			return ''
		}
	}

	focusTab(){
		const modal = $("#" + this.props.modalId);
		if(modal.is(":visible") && this.props.modalId === "custom-modal-api"){
			modal.find('.h5-custom').focus()

			modal.find('a').unbind('keydown').keydown((e)=>{
				if(e.keyCode === 9){
					modal.find('.h5-custom').focus();
					return false;
				}

				if(e.keyCode === 13){
					e.currentTarget.click();
				}
			})
		}
	}

	render() {
		const type = this.getType();

		setTimeout(()=>{
            this.focusTab()
        }, 1000);

		return (
			<div>
				{type === 'addCustomModal' ? (
					<Realize.Modal id={this.props.modalId} dismissible={this.props.dismissible} isMobile={this.props.isMobile}>
						<Realize.ModalHeader>
						<span className="h5-custom" tabIndex="0">{this.getTitle()}</span>
						</Realize.ModalHeader>
						<Realize.ModalContent>
							<div className="process-help-modal__item">
								<p tabIndex="0">{this.getDescription()}</p>
							</div>
						</Realize.ModalContent>
						<Realize.ModalFooter className={'right-align'}>
							{this.renderModalButtons()}
						</Realize.ModalFooter>
					</Realize.Modal>
				) : (
					<Realize.Modal className="modal-loader" id={this.props.modalId} dismissible={this.props.dismissible} isMobile={this.props.isMobile} inDuration={0} outDuration={0}>
						<Realize.ModalContent>
							<div tabIndex="0">
								<p className="center-align">{this.iconModal()}</p><br/>
								<p className="center-align">{this.getDescription()}</p>
							</div>
						</Realize.ModalContent>
					</Realize.Modal>
				)}
			</div>
		)
	}
}
